import { useEffect, useState } from "react";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ChangerBureauModal({ authUser, currentBureau, onSelect, onClose }) {
  const [bureaux, setBureaux] = useState([]);
  const [choix, setChoix] = useState(currentBureau);
  const autorises = authUser?.bureaux?.length ? authUser.bureaux : [authUser?.bureau].filter(Boolean);

  useEffect(() => {
    if (!authUser?.region) return;
    axios.get(`${API}/reference/bureaux-by-region`, { params: { region: authUser.region }, withCredentials: true })
      .then(r => setBureaux((r.data || []).filter(b => autorises.includes(b.code))))
      .catch(() => setBureaux([]));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [authUser?.region]);

  return (
    <div className="popup-overlay" onClick={onClose}>
      <div
        className="etab-modal"
        onClick={e => e.stopPropagation()}
        style={{ maxWidth: 420, width: "90%" }}
        data-testid="changer-bureau-modal"
      >
        <div className="popup-header" style={{ background: "#0033A0", padding: "6px 12px" }}>
          <span className="popup-title">Changer de bureau</span>
          <button className="win-modal-close" onClick={onClose} data-testid="changer-bureau-btn-x">×</button>
        </div>
        <div style={{ padding: "14px 16px" }}>
          <div style={{ fontSize: "12px", marginBottom: "10px" }}>
            Sélectionnez le bureau de travail à utiliser. Seuls les bureaux autorisés
            dans votre fiche sont proposés.
          </div>
          <div style={{ border: "1px solid #a0a0a0", background: "#fff", maxHeight: "220px", overflowY: "auto" }}>
            {bureaux.map(b => (
              <label key={b.code}
                     style={{
                       display: "flex", alignItems: "center", gap: "8px", padding: "6px 10px",
                       fontSize: "12px", cursor: "pointer",
                       background: choix === b.code ? "#cce4ff" : "transparent",
                     }}>
                <input
                  type="radio"
                  name="choix-bureau"
                  data-testid={`changer-bureau-option-${b.code}`}
                  checked={choix === b.code}
                  onChange={() => setChoix(b.code)}
                />
                <span style={{ fontWeight: b.code === authUser.bureau ? "bold" : "normal" }}>
                  {b.code} - {b.bureau}
                  {b.code === authUser.bureau ? " (bureau par défaut)" : ""}
                  {b.code === currentBureau ? "  ← actuel" : ""}
                </span>
              </label>
            ))}
            {bureaux.length === 0 && (
              <div style={{ padding: "10px", fontSize: "12px", color: "#888" }}>
                Aucun bureau autorisé trouvé pour votre région.
              </div>
            )}
          </div>
          <div style={{ marginTop: "12px", display: "flex", justifyContent: "flex-end", gap: "10px" }}>
            <button className="win-btn" onClick={onClose} data-testid="changer-bureau-annuler">Annuler</button>
            <button
              className="win-btn"
              style={{ fontWeight: "bold" }}
              data-testid="changer-bureau-ok"
              onClick={() => { onSelect(choix); onClose(); }}
              disabled={!choix}
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
